import uploadsservicesgunChargesimageshutterstock_2135243649500x282Jpg from "$lib/data/generated/uploads/services/Gun Charges/image/shutterstock_2135243649 500x282.jpg";

export const uploads = {
  "uploads/services/Gun Charges/image/shutterstock_2135243649 500x282.jpg": uploadsservicesgunChargesimageshutterstock_2135243649500x282Jpg
};